$dependencyManager.addDependencyCallback('swiper', () => {
    class ImageRowSlider {
        constructor(container) {
            this.container = jQuery(container);
            this.slider = this.container.find('> .mad-slider');
            this.sliderId = this.container.data('slider-id');
            this.loop = this.slider.data('loop') == true;

            this.slidesCount = {
                largeDesktop: this.slider.data('slides-count-desktop') || 4,
                desktop: this.slider.data('slides-count-desktop') || 3,
                tablet: this.slider.data('slides-count-tablet') || 3,
                mobile: this.slider.data('slides-count-mobile') || 2,
                smallMobile: this.slider.data('slides-count-small-mobile') || 1
            };
            
            this.autoplay = this.slider.data('auto-play') == true;
            this.autoplayDelay = parseInt(this.slider.data('auto-play-delay')) || 4000;
            this.displayPagination = this.slider.data('display-pagination') == true;

            this.caseStudyContainer = jQuery(`.mad-case-study__image-slider > .mad-slider__container[data-slider-id="${this.sliderId}"]`)
            this.caseStudyMode = this.caseStudyContainer.length > 0

            this.swiper = null;

            this.initSlider();

            this.container.css('opacity', '1');
        }

        initSlider() {
            // Configure slider options
            const swiperOptions = {
                slidesPerView: 1,
                loop: this.loop,
                centeredSlides: false,
                slideClass: 'mad-slider__slide',
                wrapperClass: 'mad-slider__slides',
                navigation: {
                    nextEl: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__button-next`,
                    prevEl: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__button-prev`,
                },
                updateOnWindowResize: true,
                breakpoints: {
                    480: {
                        slidesPerView: this.caseStudyMode ? 2 : this.slidesCount.mobile,
                    },
                    768: {
                        slidesPerView: this.caseStudyMode ? 2 : this.slidesCount.tablet,
                    },
                    991: {
                        slidesPerView: this.caseStudyMode ? 2 : this.slidesCount.desktop,
                    },
                    1200: {
                        slidesPerView: this.caseStudyMode ? 2 : this.slidesCount.largeDesktop,
                    },
                }
            };
            
            // Add pagination if enabled
            if (this.displayPagination) {
                swiperOptions.pagination = {
                    el: `.mad-slider__container[data-slider-id="${this.sliderId}"] .swiper-pagination`,
                    clickable: true
                };
            }
            
            // Add autoplay if enabled
            if (this.autoplay) {
                swiperOptions.autoplay = {
                    delay: this.autoplayDelay,
                    disableOnInteraction: false
                };
            }

            // Initialize the slider with all configured options
            this.swiper = new Swiper(`.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__slides-container`, swiperOptions);
        }
    }

    jQuery('.mad-slider__container--image-row').each(function () {
        new ImageRowSlider(this);
    });
});